module.exports = __webpack_public_path__ + "img/5302.56a01edb.png";